import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class CallUs extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get people() {
    return get(this, '_people', []);
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/CallUs.model.js